module.exports = __webpack_public_path__ + "044bff9257208fa37a35ed44719017dc.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/phyto/vitamin-cream.jpg
 ** module id = 484
 ** module chunks = 0
 **/